import { render, staticRenderFns } from "./ReceivedRewardsPage.vue?vue&type=template&id=99163946&scoped=true&"
import script from "./ReceivedRewardsPage.vue?vue&type=script&lang=js&"
export * from "./ReceivedRewardsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99163946",
  null
  
)

export default component.exports